import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { HomeService } from "./home.service";

@Injectable()
export class HomeResolve implements Resolve<any> {
  constructor(private home: HomeService) {}

  resolve(route: ActivatedRouteSnapshot) {
    // Get query Params
    return this.home.resolvePage(route);
  }
}
